export const callSettingType = {
  GET_CALL_SETTING_DATA: "GET_CALL_SETTING_DATA",
  CLEAR_CALL_SETTING: "CLEAR_CALL_SETTING",
};
